import { IconButton, styled } from "@mui/material";
import { THEME } from "../../config";

export const SelectionIconButton = styled(IconButton)(() => ({
    zIndex: 4,
    position: "absolute",
    backgroundColor: THEME.palette.primary.main
}));
